<script>
export default {
    name: "SetCampus",
    props: {
        campusId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            campuses: [],
            filteredCampus: [],
            selectedCampus: null,
        };
    },
    methods: {
        hideModal() {
            this.$bvModal.hide("transfer-campus-modal");
        },

        dropData() {
            this.$swal({
                title: "Are you sure?",
                text: "You are about to transfer this fund source to another campus!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, transfer it!",
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit("changeCampus", JSON.parse(JSON.stringify(this.selectedCampus)));
                    this.selectedCampus = null;
                }
            });
        },
        getCampuses() {
            this.$store.dispatch("campus/GetCampus").then((response) => {
                this.campuses = response.data;
                this.filteredCampus = this.campuses
                    .filter((campus) => campus.id !== this.campusId)
                    .map((item) => ({
                        value: item.id,
                        text: item.campusName,
                    }));
                this.filteredCampus.unshift({
                    value: null,
                    text: `"Select ${this.GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}..."`,
                    disabled: true,
                });
            });
        },
    },
    created() {
        this.getCampuses();
    },
};
</script>

<template>
    <b-modal id="transfer-campus-modal"
             :title="`Set ${GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}`"
             size="sm"
             title-class="font-18"
             hide-footer
             no-close-on-backdrop>
        <div class="mb-3">
            <label for="name">{{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}} </label>
            <b-form-select v-model="selectedCampus"
                           :options="filteredCampus"
                           class="form-select"></b-form-select>
        </div>
        <div class="modal-footer">
            <button type="button"
                    class="btn btn-primary"
                    @click="dropData">
                Transfer {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
            </button>
            <button type="button"
                    class="btn btn-link"
                    @click="hideModal">Close</button>
        </div>
    </b-modal>
</template>
